const loadScript = (url, timeout = 10000, doc = document) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error(`Loading of ${url} timed out.`))
    }, timeout)
    const s = doc.createElement('script')
    s.src = url
    s.onload = resolve
    doc.body.appendChild(s)
  })
}

export default loadScript
